import React, { useEffect, useCallback, useState} from 'react';
import ModuleSys5 from "components/system5/ModuleSys5.js";
import {connect} from 'react-redux';

const Modules = ({playing, sequencerEngine}) => { 
    if (!sequencerEngine || !sequencerEngine.subSequences) { return ''; };
    let className = "modules";
    if (playing) {
        className += " playing";
    }
    return (
        <div className={className}>
          {sequencerEngine.subSequences.slice(0, 1).map(
            sub =>
                <ModuleSys5 showPads={true} subSequence={sub}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      num: props.sequencerEngine && props.sequencerEngine.subSequences &&
          props.sequencerEngine.subSequences.length,
      playing: props.sequencerEngine && props.sequencerEngine.playing
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Modules);
